<template>
  <GlobalAlertWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules" label-width="130px" label-suffix="：" inline>
      <div>
        <el-form-item label="登录账号" prop="username">
          <el-input v-model="form.username" placeholder="请输入登录账号" v-trim/>
        </el-form-item>
      </div>
      <div>
        <el-form-item label="所属区域" prop="cityId">
          <div class="address">
            <el-select v-model="form.provinceId" placeholder="请选择省份" @change="selectProvince">
              <el-option
                v-for="item in province()"
                :key="item.id"
                :value="item.id"
                :label="item.name"
              ></el-option>
            </el-select>
            <el-select v-model="form.cityId" placeholder="请选择城市">
              <el-option
                v-for="item in cities"
                :key="item.id"
                :value="item.id"
                :label="item.name"
              ></el-option>
            </el-select>
          </div>
        </el-form-item>
      </div>
      <div>
        <el-form-item label="姓名" prop="realname">
          <el-input v-model="form.realname" placeholder="请输入姓名" v-trim/>
        </el-form-item>
      </div>
      <div>
        <el-form-item label="手机号" prop="mobile">
          <el-input v-model="form.mobile" placeholder="请输入手机号" v-trim/>
        </el-form-item>
      </div>
    </el-form>
  </GlobalAlertWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalAlertWindow from '@/components/common/GlobalAlertWindow'
import { checkMobile, nameRule, creditCode } from '@/utils/form'
import { treeList } from '@/api/business/areas'
export default {
  name: 'OperaCompanyUserWindow',
  extends: BaseOpera,
  components: { GlobalAlertWindow },
  data () {
    let newRule = (rule, value, callback) => {
      if (!this.form.provinceId) {
        callback(new Error('请先选择省份'))
      } else if (!this.form.cityId) {
        callback(new Error('请先选择城市'))
      } else {
        callback()
      }
    }
    return {
      // 表单数据
      form: {
        id: null,
        realname: '',
        username: '',
        provinceId: '',
        cityId: '',
        mobile: '',
        password: '123456',
        type: '6' // 专家
      },
      cities: [],
      // 验证规则
      rules: {
        username: [
          { required: true, message: '请输入登录账号', trigger: 'blur' }
        ],
        cityId: [
          { required: true, validator: newRule, trigger: 'change'}
        ],
        realname: [
          { required: false, validator: nameRule, trigger: 'blur' }
        ],
        mobile: [
          { required: false, validator: checkMobile, trigger: 'blur' }
        ]
      }
    }
  },
  inject: ['province'],
  created () {
    this.config({
      api: '/business/account',
      'field.id': 'id'
    })
  },
  methods: {
    open(title, target, type, baseForm) {
      this.title = title
      this.visible = true
      this.type = type
      this.baseForm = baseForm
      this.form.provinceId = ''
      this.form.cityId = ''
      if (target == null) {
        this.$nextTick(() => {
          this.$refs.form.resetFields()
          this.form[this.configData['field.id']] = null
        })
        return
      }
      this.$nextTick(() => {
        this.$refs.form.resetFields()
        for (const key in this.form) {
          this.form[key] = target[key]
        }
        this.selectProvince(this.form.provinceId, true)
      })
    },
    defaultCity(){
      if(this.form.provinceId != null) {
        const tempProvince = this.province().find(item => item.id === this.form.provinceId)
        if (tempProvince) {
          this.cities = tempProvince.childList
        }
      }
    },
    // 选择省份
    selectProvince(val, isInit) {
      this.cities = []
      if (!isInit) {
        this.form.cityId = ''
      }
      treeList({ type: 1, parentId: val })
        .then(res => {
          this.cities = res
        })
    },
    
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/alertstyle.scss";
</style>
